module.exports = __webpack_public_path__ + "static/media/ZSM.8299420f.pdf";